import {types} from '../types/types';


export const uiOpenModalMonitorAction = () => ({
    type: types.uiOpenModalMonitor
});

export const uiCloseModalMonitorAction = () => ({
    type: types.uiCloseModalMonitor
});